// Copyright Prashant Vaghela, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0

export function PageBanner() {
  // noop in this design
  return null;
}
